import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useMutation } from 'react-query'
import { buildErrorMessage } from 'utils'
import { reportError } from 'utils/error'

export const useRefreshBestPerformingPosts = ({
  externalIntegrationId,
  postedAfter,
}: {
  externalIntegrationId: number
  postedAfter?: string
}) => {
  const workspaceId = useCurrentWorkspaceId()

  return useMutation(async () => {
    const response = await sendToApi(
      `/w/${workspaceId}/external_integrations/${externalIntegrationId}/refresh_best_performing_posts`,
      {
        method: 'PUT',
        body: {
          from_date: postedAfter,
        },
      },
    )

    if (response.type !== SUCCESS_RESPONSE_TYPE) {
      reportError('Failed to refresh best performing posts', {
        metaData: {
          response: response.data,
        },
      })
      throw new Error(
        buildErrorMessage(response.data.errors) ||
          'An error occurred! Our team has been notified and we are looking into it.',
      )
    }

    return response.data
  })
}
